import React from 'react'
import AmbulatorySolicitationLayout from 'presentation/doctor/layouts/AmbulatorySolicitation'

function AmbulatorySolicitation() {
  return <AmbulatorySolicitationLayout />
}

export default AmbulatorySolicitation
